import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { SessionStore } from './session.store';
import { JwtHelperService } from '@auth0/angular-jwt';
let SessionQuery = class SessionQuery extends Query {
    constructor(store, _jwtHelper) {
        super(store);
        this.store = store;
        this._jwtHelper = _jwtHelper;
        this.userInfo$ = this.select((state) => state.userInfo);
    }
    userInfo() {
        return this.getValue().userInfo;
    }
    get user() {
        // return this.getValue().user;
        return {};
    }
};
SessionQuery.ctorParameters = () => [
    { type: SessionStore },
    { type: JwtHelperService }
];
SessionQuery = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [SessionStore, JwtHelperService])
], SessionQuery);
export { SessionQuery };
